import FrameSelect from '@screens/frame/select'

export default function FrameSelectPage() {
  return <FrameSelect />
}
